<template>
  <div>
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand bg-sts navbar-light">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="pushmenu"
            href="#"
            role="button"
            ><i class="fas fa-bars"></i
          ></a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a href="/" class="nav-link font-weight-bold text-white">Inicio</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a href="#" class="nav-link font-weight-bold text-white">Contacto</a>
        </li>
      </ul>

      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <!-- Navbar Search -->
       <!--  <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="navbar-search"
            href="#"
            role="button"
          >
            <i class="fas fa-search"></i>
          </a>
          <div class="navbar-search-block">
            <form class="form-inline">
              <div class="input-group input-group-sm">
                <input
                  class="form-control form-control-navbar"
                  type="search"
                  placeholder="Buscar"
                  aria-label="Search"
                />
                <div class="input-group-append">
                  <button class="btn btn-navbar" type="submit">
                    <i class="fas fa-search"></i>
                  </button>
                  <button
                    class="btn btn-navbar"
                    type="button"
                    data-widget="navbar-search"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li> -->

        <li class="nav-item">
          <div class="custom-control custom-switch nav-link ">
            <input
              type="checkbox"
              class="custom-control-input"
              id="toggleDarkMode"
              :checked="$store.getters.getDarkMode"
              @change="toggleDarkMode"
            />
            <label class="custom-control-label text-white" for="toggleDarkMode">
              <i class="fas fa-moon mr-1"></i>
            </label>
          </div>
        </li>

        <!-- Messages Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link text-white" data-toggle="dropdown" href="#">
            <i class="far fa-comments"></i>
            <span class="badge badge-danger navbar-badge">3</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <a href="#" class="dropdown-item">
              <!-- Message Start -->
              <div class="media">
                <!--  <img
                  src="dist/img/user1-128x128.jpg"
                  alt="User Avatar"
                  class="img-size-50 mr-3 img-circle"
                /> -->
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    Brad Diesel
                    <span class="float-right text-sm text-danger"
                      ><i class="fas fa-star"></i
                    ></span>
                  </h3>
                  <p class="text-sm">Call me whenever you can...</p>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock mr-1"></i> 4 Hours Ago
                  </p>
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <!-- Message Start -->
              <div class="media">
                <img
                  src="dist/img/user8-128x128.jpg"
                  alt="User Avatar"
                  class="img-size-50 img-circle mr-3"
                />
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    John Pierce
                    <span class="float-right text-sm text-muted"
                      ><i class="fas fa-star"></i
                    ></span>
                  </h3>
                  <p class="text-sm">I got your message bro</p>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock mr-1"></i> 4 Hours Ago
                  </p>
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <!-- Message Start -->
              <div class="media">
                <img
                  src="dist/img/user3-128x128.jpg"
                  alt="User Avatar"
                  class="img-size-50 img-circle mr-3"
                />
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    Nora Silvester
                    <span class="float-right text-sm text-warning"
                      ><i class="fas fa-star"></i
                    ></span>
                  </h3>
                  <p class="text-sm">The subject goes here</p>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock mr-1"></i> 4 Hours Ago
                  </p>
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item dropdown-footer"
              >See All Messages</a
            >
          </div>
        </li>
        <!-- Notifications Dropdown Menu -->
        <!-- <li class="nav-item dropdown">
          <a class="nav-link text-white" data-toggle="dropdown" href="#">
            <i class="far fa-bell"></i>
            <span class="badge badge-warning navbar-badge">15</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <span class="dropdown-item dropdown-header">15 Notifications</span>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <i class="fas fa-envelope mr-2"></i> 4 new messages
              <span class="float-right text-muted text-sm">3 mins</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <i class="fas fa-users mr-2"></i> 8 friend requests
              <span class="float-right text-muted text-sm">12 hours</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <i class="fas fa-file mr-2"></i> 3 new reports
              <span class="float-right text-muted text-sm">2 days</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item dropdown-footer"
              >See All Notifications</a
            >
          </div>
        </li> -->
        <li class="nav-item">
          <a
            class="nav-link text-white"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i class="fas fa-expand-arrows-alt"></i>
          </a>
        </li>
        
        <li class="nav-item">
          <a class="nav-link text-white" data-toggle="dropdown" href="#">
            <i class="fas fa-th-large"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
            <!-- <span class="dropdown-item dropdown-header">15 Notifications</span> -->
            <div class="card card-widget widget-user-2 p-0 m-1">
              <!-- Add the bg color to the header using any of the bg-* classes -->
              <div class="widget-user-header bg-sts mr-0">
                <!-- /.widget-user-image -->
                <h4 class="text-white">
                  <b>{{ this.$store.state.user.name }}</b>
                </h4>
                <hr style="border: 1px solid white" />
                <!-- <h5 class="text-white" style="display: inline">
                  <b>Cargo:</b>
                </h5>
                <h6 class="text-white" style="display: inline">
                  {{ this.$store.state.user.charge }}
                </h6>
                <h5
                  class="text-white"
                  style="display: inline"
                  v-if="this.$store.state.user.empresas.length > 0"
                >
                  <b>Empresa:</b>
                </h5>
                <h6
                  class="text-white"
                  style="display: inline"
                  v-if="this.$store.state.user.empresas.length > 0"
                >
                  {{ this.$store.state.user.empresas[0].razon_social }}
                </h6> -->
                <!-- <br /> -->
                <h5 class="text-white" style="display: inline">
                  <b>Correo:</b>
                </h5>
                <p class="text-white" style="display: inline">
                  {{ this.$store.state.user.email }}
                </p>
                <br />
                <h5 class="text-white" style="display: inline">
                  <b>N. Documento:</b>
                </h5>
                <p class="text-white" style="display: inline">
                  {{ this.$store.state.user.n_document }}
                </p>
                <br />
                <h5 class="text-white" style="display: inline">
                  <b>Celular:</b>
                </h5>
                <p class="text-white" style="display: inline">
                  {{ this.$store.state.user.cel }}
                </p>
              </div>
              <div class="card-footer p-1">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <a href="#" class="nav-link">
                      <router-link to="/PerfilUsuario">
                        <i class="fa fa-user"></i> Perfil
                      </router-link>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="#"
                      class="nav-link"
                      data-toggle="modal"
                      data-target="#modal-actualizar-clave"
                    >
                      <i class="fa fa-lock"></i> Cambiar clave
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="#" @click="logout" class="nav-link">
                      <i class="fa fa-window-close"></i> Salir
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>

    <UpdatePassword />
  </div>
</template>
<script>
import UpdatePassword from "../UpdatePassword.vue";

export default {
  name: "NavBarTop",
  components: {
    UpdatePassword,
  },
  methods: {
    async logout() {
      await this.$store.dispatch("logout");
      await this.$router.push("/login");
    },
    toggleDarkMode(e) {
      const checked = Boolean(e && e.target ? e.target.checked : false);
      this.$store.dispatch("setDarkMode", checked);
    },
  },
  mounted() {},
};
</script>

<style>
@media (max-width: 767.98px) {
  .left {
    width: 230px;
  }

  .texto {
    font-size: 0.7em;
  }
}
</style>